/* unplugin-vue-components disabled */import { render } from "./MockExamAnswerCard.vue?vue&type=template&id=070efeae&scoped=true"
import script from "./MockExamAnswerCard.vue?vue&type=script&lang=js"
export * from "./MockExamAnswerCard.vue?vue&type=script&lang=js"

import "./MockExamAnswerCard.vue?vue&type=style&index=0&id=070efeae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070efeae"]])

export default __exports__